import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-brun text-warm" data-id="element-62" data-mp="3gezev8fo7z39">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32" data-id="element-63" data-mp="3ggu1cr6lbz9g">
        <div className="border-b border-warm/15 pb-16 text-center" data-id="element-64" data-mp="32ovwwtntqrjm">
          <h2 className="font-display text-4xl font-light leading-tight md:text-6xl" data-id="element-65" data-mp="36p6cmy1f4wbo">
            Redo att bjuda på något extra?
          </h2>
          <a href="#verksamheter" className="group mt-10 inline-flex items-center gap-3 rounded-full bg-warm px-9 py-4 text-sm uppercase tracking-wide2 text-brun transition-colors hover:bg-smorgul" data-id="element-66" data-mp="3ugbrb9vmhike">
            Utforska smaker
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-67" data-mp="3qcxbaj7op26y" />
          </a>
        </div>

        <div className="grid gap-12 pt-16 md:grid-cols-[1.5fr,1fr,1fr]" data-id="element-68" data-mp="29y5kubu3m50a">
          <div data-id="element-69" data-mp="2eyt76k7dtxo6">
            <p className="font-display text-2xl" data-id="element-70" data-mp="2ezbbm4477i76">Smaken som Baken</p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-warm/60" data-id="element-71" data-mp="3l9ae7kt6385h">
              All mat. Alla smaker. Samlat i Småland. Noggrant utvalda matupplevelser där smak,
              kvalitet och hantverk står i centrum.
            </p>
          </div>

          <div data-id="element-72" data-mp="3v919vptgrt75">
            <p className="text-[11px] uppercase tracking-wide2 text-warm/40" data-id="element-73" data-mp="3v5n8okwjdq1a">Utforska</p>
            <ul className="mt-5 space-y-3 text-sm text-warm/75" data-id="element-74" data-mp="3q7byua68rfj2">
              <li data-id="element-75" data-mp="81yxwl8ju251"><a href="#filosofi" className="hover:text-smorgul" data-id="element-76" data-mp="81pghm1kl3ay">Filosofi</a></li>
              <li data-id="element-77" data-mp="34pafb4q00ju"><a href="#tillfallen" className="hover:text-smorgul" data-id="element-78" data-mp="34p8v6p2nshq">Tillfällen</a></li>
              <li data-id="element-79" data-mp="htd050rvxg1v"><a href="#utbud" className="hover:text-smorgul" data-id="element-80" data-mp="htd4te2ty487">Utbud</a></li>
              <li data-id="element-81" data-mp="ctqnasfyy1tl"><a href="#verksamheter" className="hover:text-smorgul" data-id="element-82" data-mp="ctqrz5qwypzx">Verksamheter</a></li>
            </ul>
          </div>

          <div data-id="element-83" data-mp="qsqdw5n1kqse">
            <p className="text-[11px] uppercase tracking-wide2 text-warm/40" data-id="element-84" data-mp="qub81u5g27pq">Kontakt</p>
            <ul className="mt-5 space-y-3 text-sm text-warm/75" data-id="element-85" data-mp="mspq3ue1z38o">
              <li data-id="element-86" data-mp="tv4o84h2f862"><a href="mailto:hej@smakensombaken.se" className="hover:text-smorgul" data-id="element-87" data-mp="tvczjrxji5f5">hej@smakensombaken.se</a></li>
              <li data-id="element-88" data-mp="ytoak5zkmlyy">Småland, Sverige</li>
              <li className="flex gap-4 pt-2" data-id="element-89" data-mp="yupja3t46wdi">
                <a href="#top" className="hover:text-smorgul" data-id="element-90" data-mp="13tkclzopk3bv">Instagram</a>
                <a href="#top" className="hover:text-smorgul" data-id="element-91" data-mp="13rg04tcqtvzz">Nyhetsbrev</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-2 border-t border-warm/15 pt-8 text-[12px] text-warm/40 md:flex-row" data-id="element-92" data-mp="1cmdw69b6tovj">
          <p data-id="element-93" data-mp="1hj4buvj2yigf">© {new Date().getFullYear()} Smaken som Baken. Alla rättigheter förbehållna.</p>
          <p data-id="element-94" data-mp="1mkbj8thb9fmk">Smak. Kvalitet. Hantverk.</p>
        </div>
      </div>
    </footer>;
}